import './CompletedPaymentList.scss';
import {ITableColumn} from "../../../shared/models/table.model";
import {CommonService} from "../../../shared/services";
import moment from "moment-timezone";
import ToolTipComponent from "../../../shared/components/tool-tip/ToolTipComponent";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import LinkComponent from "../../../shared/components/link/LinkComponent";
import TableWrapperComponent from "../../../shared/components/table-wrapper/TableWrapperComponent";
import {APIConfig} from "../../../constants";

interface CompletedPaymentListProps {
    filterState: any;
    onSort: (key: string, order: string) => void;
}

const completedPaymentListColumns: ITableColumn[] = [
    {
        title: 'Receipt No.',
        key: 'invoice_no',
        dataIndex: 'invoice_no',
        fixed: 'left',
        render: (record: any) => {
            return (
                <>
                    {record?.receipt_number}
                </>
            )
        }
    },
    {
        title: 'Payment Date',
        key: 'billing_date',
        dataIndex: 'billing_date',
        align: 'center',
        render: (record: any) => {
            return (
                <>
                    {CommonService.getDateFromTimezone(record?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')}
                </>
            )
        }
    },
    {
        title: 'Service',
        key: 'service',
        dataIndex: 'service',
        align: 'center',
        width: 300,
        render: (record: any) => {
            return (<div>
                    <ToolTipComponent tooltip={<>
                        {record?.category_details?.name}<br/> {record?.service_details?.name}
                    </>
                    }>
                        <div>{CommonService.getFirstLetterOfEachWord(record?.category_details?.name) + (record?.category_details?.name?.length ? " - " : '') + CommonService.truncateName(record?.service_details?.name, 15)}</div>
                    </ToolTipComponent>
                </div>
            )
        }
    },
    {
        title: 'Provider Name',
        key: 'provider_name',
        dataIndex: 'provider_name',
        sortable: true,
        align: 'center',
        render: (record: any) => {
            return (
                <>
                    {record?.provider_name || 'N/A'}
                </>
            )
        }
    },
    {
        title: 'Total Amount',
        key: 'total_amount',
        dataIndex: 'total_amount',
        align: 'center',
        render: (record: any) => {
            return (
                <>
                    ${CommonService.convertToDecimals(record?.payable_amount)}
                </>
            )
        }
    },
    {
        title: 'Payment For',
        key: 'payment_for',
        dataIndex: 'payment_for',
        align: 'center',
        sortable: true,
        render: (record: any) => {
            return (
                <div>
                    <ChipComponent
                        label={record?.payment_for}
                        className={record?.payment_for}/>
                </div>
            )
        }
    },
    {
        title: 'Action',
        key: 'action',
        dataIndex: 'action',
        align: 'center',
        fixed: 'right',
        render: (record: any) => {
            return (
                <div>
                    <LinkComponent route={CommonService._routeConfig.TransactionDetails(record._id) + '?type=receipt'}>
                        View Details
                    </LinkComponent>
                </div>
            )
        }
    }
];


const CompletedPaymentListComponent = (props: CompletedPaymentListProps) => {
    const {filterState, onSort} = props;
    return (
        <div className="completed-payment-list">
            <TableWrapperComponent url={APIConfig.GET_COMPLETED_PAYMENT_LIST.URL}
                                   method={APIConfig.GET_COMPLETED_PAYMENT_LIST.METHOD}
                                   columns={completedPaymentListColumns}
                                   extraPayload={filterState}
                                   noDataText={!filterState ? 'No receipts are available at this time.' : 'No receipt was found for the applied filter.'}
                                   onSort={onSort}
            />
        </div>
    )
}
export default CompletedPaymentListComponent;
